import React, { useState, useEffect } from 'react';

import { endpoints } from './endpoints.js';
import { fetchWithJWT } from './requests.js';

function Health() {
  const [healthConnAttemps, setHealthConnAttemps] = useState(false);
  const [healthBlacklistsIP, setHealthBlacklistsIP] = useState(false);
  const [healthBlacklistsHostnames, setHealthBlacklistsHostnames] = useState(false);

  useEffect(() => {
    healthRequest(endpoints.getHealthConnectionAttamps, setHealthConnAttemps)
  }, [healthConnAttemps]);

  useEffect(() => {
    healthRequest(endpoints.getHealthBlacklistsIPLast, setHealthBlacklistsIP)
  }, [healthBlacklistsIP]);

  useEffect(() => {
    healthRequest(endpoints.getHealthBlacklistsHostnamesLast, setHealthBlacklistsHostnames)
  }, [healthBlacklistsHostnames]);

  function healthRequest(endpoint, stt) {
    fetchWithJWT(endpoint, "GET", null,
      (data) => {
        stt(data.Healthy)
      },
      console.log,
    )
  }

  function makeTag(name, state) {
    return (
      <div className="control">
        <div className="tags has-addons is-medium">
          <span className="tag is-dark">{name}</span>
          {state ? (
            <span className="tag is-primary">Good</span>
          ) : (
            <span className="tag is-danger">Bad</span>
          )}
        </div>
      </div>
    )
  }

  return (
    <div className="container block">
      <h2 className="title has-text-weight is-4 honey-text-font-family honey-text-common">
        Health
      </h2>
      <div className="card">
        <div className="card-header">
          <p className="card-header-title">Health</p>
        </div>
        <div className="card-content">
          <div className="content">
            <div className="field is-grouped is-grouped-multiline">
             {makeTag("Connection Attemps", healthConnAttemps)}
             {makeTag("Blacklist IP", healthBlacklistsIP)}
             {makeTag("Blacklist Hostnames", healthBlacklistsHostnames)}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Health;
